import LocomotiveScroll from 'locomotive-scroll';
//https://github.com/locomotivemtl/locomotive-scroll
/*
active / deactiveの機能を持たせる
drag中、500ms動きがなかったら自動でドラッグ中止
スクロールで横移動
ドラッグで上下左右移動
*/
let $html = document.documentElement;
let c = {
	green: "#BFFFF0",
	lgreen: "#F0FFC2",
	orange: "#FFE4C0",
	pink: "#FFBBBB"
}
export let PageScroll = {
	pos: [0, 0],
	isFirst: true,
	zoom: 1,
	dragParam: {
		start: [0, 0],
		diff: [0, 0],
		memo: [0, 0],
		max: [0, 0],
		min: [0, 0],
		isDragStart: false,
		timer: null
	},
	init: function(isActive){
		let $this = PageScroll;
		if( $html.classList.contains("mobile") || $html.classList.contains("ipad")){
					
		}else{
			setTimeout(function(){
				$this.scroll = new LocomotiveScroll({
					el: document.querySelector('[data-scroll-container]'),
					smooth: true,
					direction: 'horizontal',
					multiplier: 1
				});
				$this.scroll.on("scroll", (args) => {
					//console.log(args.delta.x);
					PageScroll.pos[0] = args.delta.x;
					//console.log(PageScroll.pos[0]);
				});
				$this.nav();
			}, 100);
		}
		$this.activeDrag(true);
	},
	dragStart: function(e){
		e.preventDefault();
		let d = PageScroll.dragParam;
		d.isDragStart = true;
		if( !$html.classList.contains("dragging") ){
			$html.classList.add("dragging");
		}
		d.max[1] 	= (document.querySelector("#pages ul").clientHeight - window.innerHeight)*-1;
		d.start[1] 	= e.clientY;
		d.memo[1] 	= PageScroll.pos[1];
		
		d.max[0] 	= (document.querySelector("#pages ul").clientWidth - window.innerWidth);
		d.start[0] 	= e.clientX;
		d.memo[0] 	= PageScroll.pos[0];
		//console.log("dragStart:", memoX);
	},
	dragMove: function(e){
		let $this = PageScroll;
		let d = PageScroll.dragParam;
		let $dragArea = document.querySelector("#pages");
		let $page = $dragArea.querySelector("ul");
		let dragCallback = function(){
			d.timer = null;
			$this.dragEnd();
		}
		if(d.isDragStart){
			//Y座標
			d.diff[1] = e.clientY - d.start[1] + d.memo[1];
			d.diff[1] = d.diff[1] < d.max[1] ? d.max[1] : d.diff[1];
			d.diff[1] = d.diff[1] > d.min[1] ? d.min[1] : d.diff[1];
			PageScroll.pos[1] = d.diff[1];
			//X座標
			d.diff[0] = d.start[0] - e.clientX + d.memo[0];
			d.diff[0] = d.diff[0] < d.min[0] ? d.min[0] : d.diff[0];
			d.diff[0] = d.diff[0] > d.max[0] ? d.max[0] : d.diff[0];
			PageScroll.pos[0] = d.diff[0];
			//console.log(PageScroll.pos[0]);
			$page.style.transform = `translate3d(0, ${PageScroll.pos[1]}px, 0)`;
			
			PageScroll.scroll.scrollTo(PageScroll.pos[0], {
				duration: 0,
				disableLerp: true
			});
			if(d.timer) {
				clearTimeout(d.timer);
			}
			d.timer = setTimeout(dragCallback, 500);
		}
	},
	dragEnd: function(e){
		let d = PageScroll.dragParam;
		if(d.isDragStart){
			d.isDragStart = false;
			d.start = [0, 0];
			d.diff 	= [0, 0];
			if( $html.classList.contains("dragging") ){
				$html.classList.remove("dragging");
			}
		}
	},
	activeDrag: function(isActive){
		if(isActive){
			console.log("%cActive Page Drag", `color: ${c.green}`);
		}else{
			console.log("%cdisable Page Drag", `color: ${c.green}`);
		}
		let $dragArea = document.querySelector("#pages");
		let $this = this;
		
		if(isActive){
			$dragArea.addEventListener('mousedown', $this.dragStart, false);
			$dragArea.addEventListener('mousemove', $this.dragMove, false);
			$dragArea.addEventListener('mouseup', $this.dragEnd, false);
		}else{
			$dragArea.removeEventListener('mousedown', $this.dragStart, false);
			$dragArea.removeEventListener('mousemove', $this.dragMove, false);
			$dragArea.removeEventListener('mouseup', $this.dragEnd, false);
		}
		
		if(PageScroll.isFirst){
			PageScroll.isFirst = false;
		}
	},
	nav: function(){
		let $this = PageScroll;
		let $page = document.querySelector("[data-scroll-container] #block_content #pages ul");
		let $plus = document.querySelector("#btn_zoom_plus");
		let $minus = document.querySelector("#btn_zoom_minus");
		
		PageScroll.zoom = 1;
		let beforeZoom = 0;
		checkZoomBtn();
		let zoomPlus = function(){
			beforeZoom = PageScroll.zoom;
			PageScroll.zoom += .5;
			if(PageScroll.zoom >= 3){
				PageScroll.zoom = 3;
			}
			$page.style.height = PageScroll.zoom*100 + "%";
			$this.scroll.update();
			let posX = Math.floor($this.pos[0]/beforeZoom*PageScroll.zoom);
			let posY = Math.floor($this.pos[1]/beforeZoom*PageScroll.zoom);
			//console.log($this.pos[0], posX);
			$this.scroll.scrollTo(posX, {
				duration: 0,
				disableLerp: true
			});
			$this.pos[1] = posY;
			$page.style.transform = `translate3d(0, ${posY}px, 0)`;
			checkZoomBtn();
		}
		let zoomMinus = function(){
			beforeZoom = PageScroll.zoom;
			PageScroll.zoom -= .5;
			if(PageScroll.zoom < 1){ PageScroll.zoom = 1;}
			$page.style.height = PageScroll.zoom*100 + "%";
			$this.scroll.update();
			let posX = Math.floor($this.pos[0]/beforeZoom*PageScroll.zoom);
			let posY = Math.floor($this.pos[1]/beforeZoom*PageScroll.zoom);
			$this.scroll.scrollTo(posX, {
				duration: 0,
				disableLerp: true
			});
			if($this.zoom === 1){
				posY = 0;
			}
			$page.style.transform = `translate3d(0, ${posY}px, 0)`;
			$this.pos[1] = posY;
			checkZoomBtn();
		}
		
		$plus.addEventListener("click", zoomPlus, false);
		$minus.addEventListener("click", zoomMinus, false);
		
		function checkZoomBtn(){
			let zoom = PageScroll.zoom;
			
			if(zoom >= 3){
				if( !$plus.classList.contains("disable") ){
					$plus.classList.add("disable");
				}
			}else if(zoom === 1){
				if( !$minus.classList.contains("disable") ){
					$minus.classList.add("disable");
				}
			}else{
				if( $plus.classList.contains("disable") ){
					$plus.classList.remove("disable");
				}
				if( $minus.classList.contains("disable") ){
					$minus.classList.remove("disable");
				}
			}
		}
		//debug active/disable
		/*
		let keyFunc = function(e){
			console.log(e.keyCode);
			if(e.keyCode === 68){
				$this.destroy();
			}else if(e.keyCode === 65){
				$this.init();
			}
		}
		document.body.addEventListener("keyup", keyFunc, false);
		*/
	},
	destroy: function(){
		let $this = PageScroll;
		let $page = document.querySelector("[data-scroll-container] #block_content #pages ul");
		$this.scroll.destroy();
		$this.zoom = 1;
		$this.pos[0] = 0;
		$this.pos[1] = 0;
		$page.style.height 		= "";
		$page.style.transform 	= ``;
		$this.activeDrag(false);
		//console.log("スクロール機能の削除");
	}
}